document.addEventListener('DOMContentLoaded', () => {
  const cartItems = window.cartItemsData || [];
  const isB2B = window.customerIsB2B || false;
  const customerId = window.customerId || '';

  if (!cartItems.length) return;

  const EPS = 0.01;

  cartItems.forEach((item) => {
    const lineId = item.key;
    const sku = item.sku?.split('-')[0];
    const basePrice = parseFloat(item.basePrice || 0);   // per lb
    const discountPct = parseFloat(item.discountPercentage || 0);
    const productType = item.productType || '';
    const productId = item.productId || '';

    const input = document.querySelector(`[data-id="${lineId}"]`);
    const wrapper = input?.closest('[data-hulkapps-lineitem]');
    if (!input || !wrapper) return;

    const priceDisplayElm = document.getElementById(`price-display-${lineId}`);
    const unitPriceElm = wrapper.querySelector('.final-price');
    if (!priceDisplayElm || !unitPriceElm) return;

    // The strike-through (base/original) container and span
    const basePriceElm = wrapper.querySelector('.base-price');
    const basePriceWrap = basePriceElm?.closest('.base-price-wrap');

    const updatePriceDisplay = async () => {
      const qty = parseInt(input.value) || 1;
      const needsApi = (productType === 'MTO' || productType === 'Stock') && !isB2B;

      if (!needsApi) {
        // B2B or non-dynamic: just reflect what Shopify has
        const total = parseFloat(item.linePrice || 0);
        const unit = parseFloat(item.unitPrice || 0);

        // Hide the base/original block (no discount UX in this path)
        if (basePriceWrap) basePriceWrap.style.display = 'none';

        priceDisplayElm.innerHTML = `<strong>$${total.toFixed(2)}</strong>`;
        unitPriceElm.innerHTML = `<small>$${unit.toFixed(2)} per lb</small>`;
        return;
      }

      let unitPrice, totalPrice;
      try {
        let url = 'https://app-ppgpowdercoatings-prd-prd-01.azurewebsites.net'
          + `/api/ShopifyOrderPreCalculation/price-discount?productId=${productId}&sku=${sku}&count=${qty}`;
        if (customerId) url += `&customerId=${customerId}`;
        if (discountPct) url += `&percentOff=${discountPct}`;

        const response = await fetch(url);
        const data = await response.json();

        totalPrice = parseFloat(data.totalAmount || 0);
        unitPrice = parseFloat(data.pricePerPound || 0);
      } catch (e) {
        // Fallback to base pricing math if API fails
        unitPrice = basePrice;
        totalPrice = basePrice * qty;
      }

      // Totals
      priceDisplayElm.innerHTML = `<strong>$${totalPrice.toFixed(2)}</strong>`;

      // Show or hide the BASE TOTAL (strike-through) only if base > unit (true discount)
      if (basePriceWrap) {
        if (basePrice > unitPrice + EPS) {
          basePriceWrap.style.display = '';
          // Show the original total in the strike-through (base per-lb * qty)
          basePriceElm.textContent = `$${(basePrice * qty).toFixed(2)}`;
        } else {
          basePriceWrap.style.display = 'none';
        }
      }

      // Per-lb line: only strike-through when base > unit
      const showPerLbStrike = basePrice > unitPrice + EPS;
      unitPriceElm.innerHTML = `
        <small>
          ${showPerLbStrike ? `<s style="color:#888;">$${basePrice.toFixed(2)} per lb</s> → ` : ''}
          $${unitPrice.toFixed(2)} per lb
        </small>
      `;
    };

    input.addEventListener('change', () => {
      updatePriceDisplay();
      setTimeout(() => {
        document.querySelector('input.update-cart')?.click();
      }, 1000);
    });

    updatePriceDisplay();
  });
});
